import { CustomId } from "#@/utils/customId";

export function generateId(dict:{[id:string]:any}):string {
    let newId = new CustomId();
    while (dict.hasOwnProperty(newId.asBased64())) {
        newId = new CustomId();
    }
    return newId.asBased64();
}